import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../data";

export const Footer = () => (
  <footer className="bg-primary text-slate-300">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div className="lg:col-span-1">
        <Logo light />
        <p className="mt-5 text-slate-300 leading-relaxed max-w-xs">
          Friendly, patient tech help for your home, your family, and your everyday life.
        </p>
      </div>

      <div>
        <h4 className="text-white font-bold mb-4 text-lg">Explore</h4>
        <ul className="space-y-3">
          {[
            ["/services", "Services"],
            ["/pricing", "Pricing"],
            ["/senior-tech-help", "Senior Tech Help"],
            ["/about", "About Us"],
            ["/testimonials", "Testimonials"],
          ].map(([to, label]) => (
            <li key={to}>
              <Link to={to} className="hover:text-accent transition-colors">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-white font-bold mb-4 text-lg">Support</h4>
        <ul className="space-y-3">
          {[
            ["/faq", "FAQ"],
            ["/glossary", "Tech Glossary"],
            ["/blog", "Blog"],
            ["/contact", "Contact & Booking"],
          ].map(([to, label]) => (
            <li key={to}>
              <Link to={to} className="hover:text-accent transition-colors">
                {label}
              </Link>
            </li>
          ))}
          <li>
            <button
              data-testid="footer-how-it-works"
              onClick={() => window.dispatchEvent(new Event("open-welcome"))}
              className="hover:text-accent transition-colors text-left"
            >
              How this site works
            </button>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-bold mb-4 text-lg">Get in Touch</h4>
        <ul className="space-y-3.5">
          <li>
            <a href={CONTACT.phoneHref} className="flex items-center gap-3 hover:text-accent transition-colors">
              <Phone className="h-5 w-5 text-accent shrink-0" /> {CONTACT.phone}
            </a>
          </li>
          <li className="flex items-center gap-3">
            <MapPin className="h-5 w-5 text-accent shrink-0" /> {CONTACT.location}
          </li>
          <li className="flex items-center gap-3">
            <Clock className="h-5 w-5 text-accent shrink-0" /> {CONTACT.hours}
          </li>
          <li>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-accent transition-colors">
              <Mail className="h-5 w-5 text-accent shrink-0" /> {CONTACT.email}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-300">
        <p>© {new Date().getFullYear()} The Tech Savvy Company · Columbus, Ohio</p>
        <div className="flex items-center gap-5">
          <p>TheTechSavvyCo.com</p>
          <Link to="/login" data-testid="footer-owner-login" className="hover:text-accent transition-colors">
            Owner Login
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
